const validarTelefono = (tel) => /^[0-9]*$/.test(tel);

export default { validarTelefono };
